<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js";
import {ref, watch} from "vue";
import axios from "axios";
import {useEvaluationSkillStore} from "@/stores/Evaluation/EvalautionSkill";

export default {
    setup() {
        const {
            loading,
            total,
            itemsPerPage,
            filter,
        } = useSharedData();

        const {transformFilterValues, formatedDate, formatedEvaluationCycle} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const evaluationSkillStore = useEvaluationSkillStore();
        const securityStore = useSecurityStore();

        const dynamicStepHeaders = ref([]);
        const headers = ref([]);

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_EVALUATION_SKILL'],
                disabled: (item) => item.closed,
                func: (item) => {
                    $router.push({name: 'evaluation_skills.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['DELETE_EVALUATION_SKILL'],
                disabled: (item) => item.closed,
                func: (item) => {
                    $router.push({name: 'evaluation_skills.delete', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t('common.launch'),
                icon: 'mdi-clock-start',
                color: 'cyan',
                access: () => securityStore.authorities['UPDATE_EVALUATION_SKILL'],
                disabled: (item) => item.closed,
                func: (item) => {
                    $router.push({name: 'evaluation_skills.launch', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t('module.evaluation_skill_candidates'),
                icon: 'mdi-clipboard-text-clock',
                color: 'teal',
                access: () => true,
                disabled: (item) => !item.closed,
                func: (item) => {
                    $router.push({name: 'evaluation_skill_candidates', params: {skillId: item.id}})
                },
            },
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'evaluation_skills.documents', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.template_application"),
                icon: 'mdi-text-box-multiple',
                color: 'teal',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'evaluation_skills.template_applications', params: {id: item.id}})
                },
            },
        ];

        const searchParams = ref({
            sortBy: "cycleStart",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage.value,
        });

        function handleSearch(params) {
            loading.value = true;
            evaluationSkillStore.setEvaluationSkills([]);
            total.value = 0;

            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;

            headers.value = [];
            dynamicStepHeaders.value = [];

            addHeaderHead();
            axios.get('/evaluationSkills', {params: transformFilterValues(filter.value)}).then((response) => {
                evaluationSkillStore.setEvaluationSkills(response.data.elements);
                total.value = response.data.total;

                evaluationSkillStore.evaluationSkills.forEach(element => {
                    element.steps.forEach(step => {
                        element[step.phaseName] = `${step.completedNumber + step.toleratedNumber}/${step.concernedNumber}`;
                        addHeader(step);
                    });
                });
                headers.value.push(...dynamicStepHeaders.value);
                addFooterHeader();
            }).finally(() => {
                loading.value = false;
            });
        }

        function findAll() {
            handleSearch(searchParams.value)
        }

        function addHeaderHead() {
            headers.value.push(
                {
                    text: "...",
                    align: "start",
                    sortable: false,
                    value: "action",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.code'),
                    align: "start",
                    sortable: true,
                    value: "code",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.label'),
                    align: "start",
                    sortable: true,
                    value: "name",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.period'),
                    align: "start",
                    sortable: true,
                    value: "period",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.start'),
                    align: "start",
                    sortable: true,
                    value: "cycleStart",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.end'),
                    align: "start",
                    sortable: true,
                    value: "cycleEnd",
                    width: "0%"
                },
            );
        }

        function addHeader(step) {
            if (!dynamicStepHeaders.value.some((header) => header.text === step.phaseName)) {
                dynamicStepHeaders.value.push({
                    text: step.phaseName,
                    align: "center",
                    sortable: false,
                    value: step.phaseName,
                    ordre: step.ordre + 7,
                });
            }
        }

        function addFooterHeader() {
            headers.value.push(
                {
                    text: $i18n.t('common.percent'),
                    align: "start",
                    sortable: true,
                    value: "percent",
                },
            );
        }

        watch(() => filter.value, () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});

        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
        }

        function view(item) {
            $router.push({name: 'evaluation_skills.view', params: {id: item.id}});
        }

        return {
            evaluationSkillStore,
            securityStore,
            searchParams,
            headers,
            actions,
            loading,
            total,
            itemsPerPage,
            filter,
            dynamicStepHeaders,
            clearFilter,
            findAll,
            view,
            formatedDate,
            formatedEvaluationCycle,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.evaluation_skills')"
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
            </template>

            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['SAVE_EVALUATION_SKILL']"
                    @press="$router.push({name: 'evaluation_skills.add'})"
                />
            </template>

            <template v-slot:content>
                <w-server-data-table
                    v-model="searchParams"
                    :headers="headers"
                    :actions="actions"
                    :items="evaluationSkillStore.evaluationSkills"
                    :loading="loading"
                    :total="total"
                    root-path="evaluation_skills"
                    module="EVALUATION_SKILL"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>

                    <template v-slot:[`item.period`]="{ item }">
                        <w-inline-text :text="formatedEvaluationCycle(item)"/>
                    </template>
                    <template v-slot:[`item.cycleStart`]="{ item }">
                        <w-inline-text :text="formatedDate(item.cycleStart)"/>
                    </template>
                    <template v-slot:[`item.cycleEnd`]="{ item }">
                        <w-chip color="teal" :text="formatedDate(item.cycleEnd)"/>
                    </template>

                    <!-- Dynamic slot for step headers -->
                    <template
                        v-for="header in dynamicStepHeaders"
                        v-slot:[`item.${header.value}`]="{ item }"
                    >
                        <w-chip
                            :key="header.value"
                            outlined
                            :text="item[header.value] || ''"
                        />
                    </template>

                    <template v-slot:[`item.percent`]="{ item }">
                        <v-progress-linear
                            :value="((item.completedNumber + item.toleratedNumber) * 100.0)/item.concernedNumber"
                            color="teal lighten-2"
                            buffer-value="0"
                            stream
                            height="25"
                        >
                            <strong>{{ (item.concernedNumber !== 0 ? ((item.completedNumber + item.toleratedNumber) * 100.0) / item.concernedNumber : 0).toFixed(2) }}%</strong>
                        </v-progress-linear>
                    </template>
                </w-server-data-table>
            </template>

        </w-app>

        <router-view/>
    </div>
</template>